export const allowedREIPlots = ['0200260269_C4', '0213474533_SC02_001A'];
